import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { University, BookOpen } from "lucide-react";

type TabType = "University" | "Course" | "Scholarships";

export const universityTabs = [
  {
    label: "University",
    Icon: University,
    count: 62,
    value: "University" as TabType,
  },
  {
    label: "Course",
    Icon: BookOpen,
    count: 260,
    value: "Course" as TabType,
  },
  // {
  //   label: "Scholarships",
  //   Icon: Award,
  //   count: 20,
  //   value: "Scholarships" as TabType,
  // },
];

const initialState = {
  isAddUniversity: false,
  universityActiveTab: "University" as TabType,
};

const universityFunctionalSlice = createSlice({
  name: "universityFunctional",
  initialState,
  reducers: {
    setIsAddUniversity: (state, action: PayloadAction<boolean>) => {
      state.isAddUniversity = action.payload;
    },
    setUniversityActiveTab: (state, action: PayloadAction<TabType>) => {
      state.universityActiveTab = action.payload;
    },
  },
});

export const { setIsAddUniversity, setUniversityActiveTab } =
  universityFunctionalSlice.actions;
export default universityFunctionalSlice.reducer;
